import React, { useEffect, useState, useCallback } from 'react'
import { useForm } from 'react-hook-form'
import Slider from 'react-slick'
import { images } from '../../../assets'
import { InterestImgPopup, InterestGuidePopup } from './InterestPopup'
import { RatingStar } from '../../common'
import { interestConfig } from '../../configs/interest'
import { useNavigate, useParams } from 'react-router-dom'
import { dateFormat } from '../../tools'

const Interest = () => {
  const navi = useNavigate()
  const param = useParams()
  const [commentUse, setcommentUse] = useState(true) // ai댓글 사용 여부
  const [isEdit, setIsEdit] = useState(false) // 댓글 수정 여부
  const [isReadOnlyReview,setIsReadOnlyReview] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({ mode: 'onChange' }) //수정 댓글 내용

  const [interestInfo, setInterestInfo] = useState({}) // 리뷰 상세 목록
  const [isSuccess, setIsSuccess] = useState(false) // 리뷰 등록 성공 여부

  const [imgPopupOpen, setImgPopupOpen] = useState(false) // 이미지 팝업 오픈 여부
  const [guidePopupOpen, setGuidePopupOpen] = useState(false) // 가이드 팝업 오픈 여부
  const [activeSlide, setActiveSlide] = useState(0) // 슬라이드 페이지

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    beforeChange: (current, next) => {
      setActiveSlide(next)
    },
  } //슬라이드 설정

  /** 관심 리뷰 상세 조회 */
  const getInterestInfo = useCallback(data => {
    data = {
      review_token: param.review_token,
    }
    interestConfig
      .getInterestInfo(data)
      .then(result => {
        result = {
          ...result,
          contents: result.contents.replace(/\n/g, '<br/>'),
        }
        setValue('edit_contents', result.ai_type1_comment)

        if (result.result_code === 'E00003') {
          alert('만료된 페이지입니다.')
          navi('/')
        } else if (result.result_code === 'E04011') {
          alert('이미 블라인드된 리뷰입니다.')
          navi('/')
        }

        setInterestInfo(result)
        if(result.comment_reg_status_code !== "10" || result.is_expired){
          setIsReadOnlyReview(true);
        }

      })
      .catch(error => {
        console.log(error)
        if (error.code === 'E00003') {
          alert('만료된 페이지입니다.')
          navi('/')
        } else if (error.code === 'E04011') {
          alert('이미 블라인드된 리뷰입니다.')
          navi('/')
        } else {
          alert(error.message)
          navi('/')
        }
      })
  }, [])
  useEffect(() => {
    getInterestInfo()
  }, [])
  useEffect(() => {
   if (interestInfo.important_yn === 'N') {
      alert('관심 리뷰가 아닙니다.')
      return navi('/')
    }
  }, [interestInfo])

  /** 메뉴 리스트 */
  const menuList = useCallback(
    data => {
      let list = data.split(',')
      return (
        <>
          <div className="review_menu">
            {list.map((item, i) => (
              <span key={i}>{item}</span>
            ))}
          </div>
        </>
      )
    },
    [interestInfo]
  )

  /** 배달앱 이미지 */
  const appImg = appCode => {
    if (appCode === '01') {
      return <img src={images.review_img02} alt="배민" />
    } else if (appCode === '02') {
      return <img src={images.review_img01} alt="요기요" />
    } else {
      return <img src={images.review_img03} alt="쿠팡이츠" />
    }
  }

  /** 이미지 팝업 버튼 클릭 */
  const handleImgPopupBtn = () => {
    setImgPopupOpen(!imgPopupOpen)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  /** 가이드 팝업 버튼 클릭 */
  const handleGuidePopupBtn = () => {
    setGuidePopupOpen(!guidePopupOpen)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  /** 수정 버튼 클릭 */
  const handleEditBtn = () => {
    setIsEdit(true)
    setcommentUse(false)
  }

  /** 취소 버튼 클릭 */
  const handleCancelBtn = () => {
    setIsEdit(false)
    setcommentUse(true)
    setValue('edit_contents', interestInfo.ai_type1_comment)
  }

  /** 관심 리뷰 등록 */
  const setCommentRegi = useCallback(
    data => {
      data = {
        review_token: param.review_token, //리뷰 토큰
        shop_idx: interestInfo.shop_idx, //가맹점일련번호
        store_idx: interestInfo.store_idx, //매장일련번호
        app_idx: interestInfo.app_idx, //배달앱일련번호
        comment_history_idx: interestInfo.ai_type1_comment_history_idx, //댓글history일련번호
        comment_use_type_code: interestInfo.ai_comment_use_type_code, //AI댓글사용타입코드(A/B)
        comment_use_yn: commentUse ? 'Y' : 'N', //AI댓글사용여부
        comment_modify_yn: isEdit ? 'Y' : 'N', //AI댓글수정여부
        contents: data.edit_contents, //댓글
        important_yn: interestInfo.important_yn, //관심리뷰여부
      }

      if (data.contents.length <= 0) return alert('댓글을 입력해주세요.')
      if (!window.confirm('리뷰를 등록하시겠습니까?')) return false

      interestConfig
        .setCommentRegi(data)
        .then(() => {
          alert('리뷰가 등록되었습니다.')
          setIsSuccess(true)
          navi('/')
        })
        .catch(error => alert(error.message))
    },
    [interestInfo, commentUse, isEdit]
  )

  const onSubmit = data => {
    setCommentRegi(data)
  }

  /** 관심 리뷰 블라인드 */
  const setInterestBlind = useCallback(
    data => {
      data = {
        review_token: param.review_token,
        shop_idx: interestInfo.shop_idx,
        store_idx: interestInfo.store_idx,
        app_idx: interestInfo.app_idx,
      }
      if (!window.confirm('댓글 등록 거부 신청을 하시겠습니까?')) return false

      interestConfig
        .setInterestBlind(data)
        .then(result => {
          alert('댓글 거부 신청이 완료되었습니다.')
          navi('/')
        })
        .catch(error => {
          console.log(error)
        })
    },
    [interestInfo]
  )

  return (
    <div className="Interest SubPages">
      <div className="interest_review_wrap">
        <div className="interest_review_header">
          <p className="title bold">관심 리뷰 관리</p>
          <p className="sub">
            <span className="review_count">1개</span>의 관리가 필요한 관심리뷰가 있습니다.
          </p>
        </div>
        <div className="interest_review_contents">
          <div className="review_user">
            <div className="user_img">{appImg(interestInfo.app_type_code)}</div>
            <div className="user_name">
              <div>
                <span className="name bold">{interestInfo?.member_nickname}님</span>
                <span className="name bold m_l_10"> {interestInfo?.app_type_code_etc1}</span>
              </div>
              <div className="user_rate">
                <RatingStar rank={interestInfo?.rating} />
                <div className="user_review_date">{dateFormat(interestInfo?.review_reg_dt)}</div>
              </div>
            </div>
            <button className="btn btn_guide" type="button" onClick={handleGuidePopupBtn}>
              관심 리뷰 가이드 <img src={images.review_guide_icon} alt="리뷰가이드" />
            </button>
          </div>
          <div className="review_content">
            <div className="img_content">
              {interestInfo.image_list?.length > 0 && (
                <>
                  <Slider {...settings} className="slide">
                    {interestInfo.image_list?.map((item, i) => (
                      <div key={i} style={{ width: '100%', height: '100%' }}>
                        <div
                          className="review_img"
                          style={{
                            backgroundImage: `url(${item.image_url})`,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                          }}
                          onClick={handleImgPopupBtn}
                        />
                      </div>
                    ))}
                  </Slider>
                  <div className="slide_pagination">
                    <span className="bold">{activeSlide + 1}</span> / {interestInfo.image_list?.length}
                  </div>
                </>
              )}
            </div>
            <div className="review_txt" dangerouslySetInnerHTML={{ __html: interestInfo?.contents }}></div>
            {interestInfo?.menu_name && menuList(interestInfo?.menu_name)}
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="reply_content">
              <div className={isEdit ? 'reply_edit' : 'reply_recommend'}>
                <div className={isEdit ? 'reply_edit_tit' : 'reply_recommend_tit'}>
                  <p className="bold">사장님</p>
                  {!isSuccess && (
                    <>
                      {isEdit ? (
                        <div className="btn_cancel" onClick={handleCancelBtn}>
                          <span className="close_btn"></span> 취소
                        </div>
                      ) : (
                        <div className={ `btn_edit ${isReadOnlyReview ? 'opacity-60': ''}`} onClick={isReadOnlyReview ? ()=>{} : handleEditBtn}>
                          <img src={images.btn_change} alt="수정 아이콘" /> 수정
                        </div>
                      )}
                    </>
                  )}
                </div>
                <textarea
                  rows={7}
                  placeholder="내용을 입력해주세요."
                  readOnly={!isEdit || isSuccess}
                  {...register('edit_contents', { maxLength: interestInfo.app_type_code === '03' ? 300 : 1000 })}></textarea>
                {errors.edit_contents?.type === 'maxLength' && (
                  <p className="color_r">최대 {interestInfo.app_type_code === '03' ? 300 : 1000}자 까지 작성가능합니다.</p>
                )}
              </div>
            </div>
            <div className="caution">* 금일 18:00까지 답변이 없으시면 자동으로 해당 댓글이 등록 됩니다.</div>
            {!isSuccess && (
              <div>
                <button className={ isReadOnlyReview? "bold m_b_10 btn_submit disabled-btn ":"btn btn_submit bold m_b_10"} type="submit" disabled={isReadOnlyReview}>
                  등록하기
                </button>
                {isReadOnlyReview && <div className='msg'>이미 등록된 댓글입니다.</div>}
              </div>
            )}
            <div className="review_blind" onClick={isReadOnlyReview ? ()=>{} : setInterestBlind}  disabled={isReadOnlyReview}>
              댓글 등록 거부
            </div>
          </form>
        </div>
      </div>
      {imgPopupOpen && <InterestImgPopup interestInfo={interestInfo} appImg={appImg} handleImgPopupBtn={handleImgPopupBtn} />}
      {guidePopupOpen && <InterestGuidePopup handleGuidePopupBtn={handleGuidePopupBtn} />}
    </div>
  )
}

export { Interest }
